import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminLoginMsMutation } from "../app/api";
import { saveAdminCredentials } from "../features/auth/authSlice";
import { msalRedirectResult, takeMsalReturnTo } from "../msalConfig";

export default function AuthRedirect() {
  const navigate = useNavigate();
  const [loginMs] = useAdminLoginMsMutation();
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;

    console.log('[AuthRedirect] result:', msalRedirectResult);

    // Incremental-consent return (the mobile path in YourDay): the user was
    // already signed in and only went to Microsoft to grant extra Graph scopes,
    // so there's no login to perform — just put them back on the page they left.
    // Checked before the !msalRedirectResult bail-out because a cancelled or
    // already-consented flow can come back with no result at all, and stranding
    // that user on /login would log them out of a working session.
    const returnTo = takeMsalReturnTo();
    if (returnTo && window.localStorage.getItem("token") && window.localStorage.getItem("a")) {
      navigate(returnTo, { replace: true });
      return;
    }

    if (!msalRedirectResult) {
      navigate("/login");
      return;
    }

    const email = msalRedirectResult.account.username;
    const idToken = msalRedirectResult.idToken;

    loginMs({ email, id_token: idToken, code: "" })
      .unwrap()
      .then((backendResult) => {
        saveAdminCredentials(backendResult.access_token, backendResult.uuid, email);
        navigate("/dashboard");
      })
      .catch((err) => {
        if (err?.status === 511 || err?.status === 424) {
          navigate("/login", { state: { email, idToken, need2FA: true, setup: err.status === 511 } });
        } else {
          navigate("/login", { state: { errorStatusCode: err?.status } });
        }
      });
  }, []);

  return null;
}
